export default {
	noDataText: "Aucune donnée disponible",
	loading: "Chargement...",
};
